import { GET_TOTAL_COUNT, UPDATE_CURRENT_QUERY, UPDATE_TOTAL_COUNT } from '../actions/types';
import { fetchFilterItems } from './fetchFilterItems';
import { getCurrentItems, getItemsKey, updateItems } from './filterItems';
import { scrollToSavedPosition } from './scrollPosition';

export const getDynamicFilterItems = ({
  filterType,
  queryParams,
  perPage,
  filterActions,
  currentQuery,
  eventType,
  pageNumber = 0,
}) => {
  if (!filterActions) {
    return fetchFilterItems({ filterType, perPage, pageNumber, query: queryParams });
  }

  const currentItems = getCurrentItems(filterActions, filterType);
  const totalCount = filterActions(GET_TOTAL_COUNT, null, { filterType });
  const isPagination = eventType === 'PAGINATE';
  const isFilter = eventType === 'FILTER';
  const itemsKey = getItemsKey(filterType);

  if (currentItems.length === 0 || currentQuery !== queryParams) {
    if (!isFilter && !isPagination) {
      updateItems(filterActions, filterType, []);
    }

    return fetchFilterItems({
      filterType,
      perPage,
      pageNumber,
      query: queryParams,
    }).then((res) => {
      filterActions(UPDATE_CURRENT_QUERY, queryParams, { filterType });
      const items = isPagination ? [...currentItems, ...res[itemsKey]] : [...res[itemsKey]];
      updateItems(filterActions, filterType, items);
      if (res?.totalCount) {
        filterActions(UPDATE_TOTAL_COUNT, Number(res?.totalCount), { filterType });
      }
      return res;
    });
  }

  filterActions(UPDATE_CURRENT_QUERY, queryParams, { filterType });

  scrollToSavedPosition();
  return new Promise((resolve) => {
    resolve({
      articles: currentItems,
      pageNumber: pageNumber,
      perPage,
      totalCount: totalCount,
    });
  });
};
